import { Component, Input, OnInit } from '@angular/core';
import { SipService } from '../../services/sip.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'subscriptions-transport-ws';
import { faArrowRightArrowLeft } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-transfer-call',
  templateUrl: './transfer-call.component.html',
  styleUrls: ['./transfer-call.component.css'],
})
export class TransferCallComponent implements OnInit {
  canTransfer$!: Observable<boolean>;
  faArrowRightArrowLeft = faArrowRightArrowLeft;
  
  constructor(
    private sipService: SipService,
    private snack: MatSnackBar
  ) {}

  @Input() targetCall: string | null = null;
  ngOnInit() {
    this.setupTransferAvailability();
  }

  async transfer() {
    try {
      // Get the transferable call from the centralized service
      const call = this.sipService.getTransferableCall();

      if (!call) {
        this.snack.open('No active call to transfer', 'Dismiss');
        return;
      }

      const target = this.targetCall;
      await this.sipService.transferCall(call, target!);
    } catch (error) {
      const errorMessage =
        'Failed to transfer call: ' +
        (error instanceof Error ? error.message : 'Unknown error');
      this.snack.open(errorMessage, 'Dismiss');
    }
  }

   private setupTransferAvailability(): void {
    // Use the centralized transfer state from SipService instead of creating per-component observables
    this.canTransfer$ = this.sipService.canTransfer$;
  }
}
